<template>
  <div>
    <p>
      {{$t('help.message_center.description')}}
    </p>
    <div class="mt-4 mb-2 menu" :class="{active: openParagraph === 'create'}" @click="setParagraph('create')">
      <svg-icon name="arrow_right"/><h5 class="d-inline mx-2"><b>{{$t('help.message_center.create.title')}}</b></h5>
    </div>
    <div class="menu-item" :class="{active: openParagraph === 'create'}">
      <ul>
        <li>{{$t('help.message_center.create.tab')}}</li>
        <li>{{$t('help.message_center.create.new')}}</li>
        <li>{{$t('help.message_center.create.name')}}</li>
        <li>{{$t('help.message_center.create.text')}}</li>
        <li>{{$t('help.message_center.create.publish')}}</li>
        <li>{{$t('help.message_center.create.send')}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import SvgIcon from "paperclip-lib/src/components/SvgIcon";
export default {
  name: 'MessageCenterHelp',
  components: { SvgIcon },
  data() {
    return {
      openParagraph: "",
    }
  },
  methods: {
    setParagraph(string) {
      this.openSubtypes = false
      this.openParagraph === string ? this.openParagraph = '' : this.openParagraph = string
    }
  }
}
</script>